var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("stock-scanner")))]),
      _vm.hasStockModule
        ? _c(
            "w-card-content",
            [
              _c("w-multi-select", {
                attrs: {
                  label: _vm.$ct("stock-locations"),
                  items: _vm.items,
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.onChange()
                  },
                },
                model: {
                  value: _vm.config.CalculateLocations,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "CalculateLocations", $$v)
                  },
                  expression: "config.CalculateLocations",
                },
              }),
            ],
            1
          )
        : _c(
            "w-card-content",
            [_c("app-missing-module", { attrs: { "module-id": _vm.module } })],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }